import Image from "next/image";
import React from "react";

const timelineData = [
    {
        // year: "2026 - Current",
        content: (
            <>
                <p className="mb-2">
                    Now I'm looking for the Opportunity.
                </p>
            </>
        ),
    },
    {
        // year: "2024 - 2025",
        image: 'paras-solutions.png',
        style: "w-35 pb-2",
        content: (
            <>
                <p className="mb-2">
                    Worked as a <span className="font-semibold">Software Engineer</span> at{" "}
                    <span className="text-blue-600 font-medium">Paras Solutions</span>, contributing to scalable web applications and data-driven platforms.
                </p>

                <p className="mb-2">
                    <span className="font-semibold">Developed</span> the{" "}
                    <span className="text-blue-600 font-medium">IFL Portal</span> for loan data visualization, including Excel upload functionality for seamless data ingestion.
                </p>

                <p className="mb-2">
                    <span className="font-semibold">Engineered</span> a high-performance{" "}
                    <span className="text-blue-600 font-medium">filtering API</span>, significantly improving data retrieval speed and efficiency.
                </p>

                <p className="mb-2">
                    <span className="font-semibold">Led development</span> of the{" "}
                    <span className="text-blue-600 font-medium">RBL Project</span>, enabling direct product ordering through the portal.
                </p>

                <p className="mb-2">
                    Built a responsive frontend using{" "}
                    <span className="text-blue-600 font-medium">React.js</span> and optimized backend services with{" "}
                    <span className="text-blue-600 font-medium">Node.js</span> and{" "}
                    <span className="text-blue-600 font-medium">MongoDB</span>.
                </p>

                <p className="mb-2">
                    <span className="font-semibold">Designed</span> a serverless architecture for the{" "}
                    <span className="text-blue-600 font-medium">Piramal Portal</span> using{" "}
                    <span className="text-blue-600 font-medium">AWS S3</span> and{" "}
                    <span className="text-blue-600 font-medium">MongoDB</span>, enhancing scalability and reducing operational costs.
                </p>

                <p className="mt-3">
                    <span className="font-semibold">Letter of Recommendation:</span>{" "}
                    <a
                        href="pdf/Aman Gupta LOR.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 font-semibold hover:underline hover:text-blue-800 transition"
                    >
                        View Document
                    </a>
                </p>
            </>
        ),
    },
    {
        year: "2023 - 2026",
        image: 'mu.png',
        content: (
            <>
                <p className="mb-2">
                    Pursuing a <span className="font-semibold">Bachelor of Science (B.Sc.) in Information Technology</span> from{" "}
                    <span className="text-blue-600 font-medium">University of Mumbai</span>.
                </p>

                <p className="mb-2">
                    Built a strong foundation in <span className="font-semibold">software development</span>,{" "}
                    <span className="text-blue-600 font-medium">data structures</span>, and{" "}
                    <span className="text-blue-600 font-medium">database systems</span>.
                </p>

                <p className="mb-2">
                    Developed a growing interest in{" "}
                    <span className="font-semibold">Machine Learning</span> and{" "}
                    <span className="font-semibold">Deep Learning</span>, driven by curiosity to understand how intelligent systems learn from data and solve real-world problems.
                </p>

                <p className="mb-2">
                    Actively exploring concepts such as{" "}
                    <span className="text-blue-600 font-medium">neural networks</span>,{" "}
                    <span className="text-blue-600 font-medium">computer vision</span>, and{" "}
                    <span className="text-blue-600 font-medium">natural language processing</span>, with a focus on building practical, impactful applications.
                </p>
            </>
        ),
    },
];

export default function TimeLine() {
    return (
        <div className="max-w-7xl mx-auto space-y-10 border-b border-slate-50">
            <div className="p-10">
                <div className="relative border-l-2 border-gray-300 ml-3">
                    {timelineData.map((item, index) => (
                        <div key={index} className="mb-10 ml-6">
                            {/* Dot */}
                            <span className="absolute -left-1.5 flex items-center justify-center w-3 h-3 bg-gray-400 rounded-full ring-4 ring-white"></span>

                            {item.image? <img src={item.image} className={item.style ? item.style : `w-20`} alt="image" />: ''}
                            
                            {/* Year */}
                            <time className="block mb-2 text-sm text-gray-500">
                                {item.year}
                            </time>

                            {/* Content */}
                            <div className="text-gray-700 text-sm leading-relaxed">
                                {item.content}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
